import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ScrollContainer = styled(Box)(({ theme }) => ({
  maxHeight: '300px',
  overflowY: 'auto',
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up('sm')]: {
    maxHeight: '350px',
    padding: theme.spacing(3),
  },
  [theme.breakpoints.up('md')]: {
    maxHeight: '400px',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
    [theme.breakpoints.up('sm')]: {
      width: '8px',
    },
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[400],
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.palette.grey[500],
    },
  },
}));

export interface ScrollableContentProps {
  children: React.ReactNode;
  className?: string;
}

export const ScrollableContent: React.FC<ScrollableContentProps> = ({
  children,
  className,
}) => {
  return <ScrollContainer className={className}>{children}</ScrollContainer>;
};

export default ScrollableContent;
